/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled               from 'styled-components';
import { Colours, Spacing } from '../../../styles/variables';
import { Media }            from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledFooter = styled.footer`
  background: ${Colours.Carnation};
  color: ${Colours.White};
  padding: 0 ${Spacing.Small};
  flex: none;
  display: flex;
  align-items: center;
  height: 80px;
  ${Media.Tablet`
    padding: 0 ${Spacing.Medium};
    height: 60px;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledFooter/index.js